function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.28 28.6133C53.6885 28.1749 53.9109 27.5951 53.9003 26.996C53.8897 26.3969 53.647 25.8253 53.2233 25.4017C52.7997 24.978 52.228 24.7353 51.629 24.7247C51.0299 24.7141 50.45 24.9365 50.0117 25.345L31.6042 43.7525L23.9883 36.1367C23.55 35.7282 22.9702 35.5058 22.3711 35.5164C21.772 35.5269 21.2004 35.7696 20.7767 36.1933C20.353 36.617 20.1103 37.1886 20.0997 37.7877C20.0892 38.3868 20.3115 38.9666 20.72 39.405L29.97 48.655C30.4036 49.088 30.9914 49.3313 31.6042 49.3313C32.217 49.3313 32.8048 49.088 33.2383 48.655L53.28 28.6133Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37 3.08334C18.2688 3.08334 3.08337 18.2688 3.08337 37C3.08337 55.7313 18.2688 70.9167 37 70.9167C55.7313 70.9167 70.9167 55.7313 70.9167 37C70.9167 18.2688 55.7313 3.08334 37 3.08334ZM7.70837 37C7.70837 29.2314 10.7945 21.7809 16.2877 16.2877C21.781 10.7944 29.2314 7.70834 37 7.70834C44.7687 7.70834 52.2191 10.7944 57.7124 16.2877C63.2056 21.7809 66.2917 29.2314 66.2917 37C66.2917 44.7686 63.2056 52.2191 57.7124 57.7123C52.2191 63.2056 44.7687 66.2917 37 66.2917C29.2314 66.2917 21.781 63.2056 16.2877 57.7123C10.7945 52.2191 7.70837 44.7686 7.70837 37Z",
  fill: "white"
});

var SvgOk = function SvgOk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ok.5048489e.svg";
export { ForwardRef as ReactComponent };